import * as React from "react";
import { useNavigate } from "react-router-dom";

interface LinkAnchorProps {
    path: string;
    label: string;
}

const LinkAnchor = ({ path, label }: LinkAnchorProps) => {
    const navigate = useNavigate();
    return (
        <a
            href={path}
            onClick={(e) => {
                e.preventDefault();
                navigate(path);
            }}
            className="text-text hover:text-brand cursor-pointer no-underline hover:underline"
        >
            {label}
        </a>
    );
};

export default LinkAnchor;
